module.exports = __webpack_public_path__ + "img/courier-canadapost.6d9ec81d.svg";